module["exports"] = [
  "Ramsay Street",
  "Bonnie Doon",
  "Cavill Avenue",
  "Queen Street"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/address/street_root.js
// module id = 596
// module chunks = 0